import React, { useState } from 'react';
// @ts-ignore
import styles from './PatientProfileButton.module.scss';
import { User } from '../../../../graphql/graphql';
import { joinClasses } from '../../../../Utils/className.util';
import PatientProfileLiteModal from '../PatientProfileLite/PatientProfileLiteModal';
import TreatmentModal from '../../../../Components/Treatment/TreatmentModal';

interface Props {
	patient: User;
	workplaceId: string;
	caseId?: string;
	className?: string;
}

const PatientProfileButton: React.FC<Props> = ({
	patient,
	className,
	caseId,
	workplaceId,
}) => {
	const [isProfileOpen, setIsProfileOpen] = useState(false);
	const [isLiteProfileOpen, setIsLiteProfileOpen] = useState(false);

	const profile = patient.profile;

	//OPEN LITE PROFILE IF THERE IS NO WORKPLACE PATIENT
	const handleOpenPatientProfile = () => {
		if (patient.workplacePatient) {
			setIsProfileOpen(true);
		} else {
			setIsLiteProfileOpen(true);
		}
	};

	if (!profile) {
		return <></>;
	}

	return (
		<>
			<div
				className={joinClasses([styles.button, className])}
				onClick={handleOpenPatientProfile}>
				<span>{profile.fullName}</span>
			</div>
			{isLiteProfileOpen && (
				<PatientProfileLiteModal
					isOpen
					patient={patient}
					caseId={caseId}
					onClose={() => setIsLiteProfileOpen(false)}
				/>
			)}
			{isProfileOpen && (
				<TreatmentModal
					opened
					onClose={() => setIsProfileOpen(false)}
					patientId={patient.id}
					workplaceId={workplaceId}
				/>
			)}
		</>
	);
};

export default PatientProfileButton;
